import React from 'react';
import classnames from 'classnames';
import './service-card.css';
import classNames from 'classnames';

class ServiceCard extends React.Component {

    get className() {
        return classNames(this.props.className, 'service-card');
    }

    renderIcon() {
        const { iconType, iconValue } = this.props;
        
        switch (iconType) {
            case 'EMOJI':
                return <span className="emoji-icon">{iconValue}</span>;
            case 'FONT_AWESOME':
                return <i className={`fas ${iconValue}`}></i>;
            case 'MATERIAL_ICON':
                return <i className="material-icons">{iconValue}</i>;
            case 'SVG':
                return <div dangerouslySetInnerHTML={{ __html: iconValue }} />;
            case 'IMAGE_URL':
                return <img src={iconValue} alt={this.props.title} className="icon-image" />;
            default:
                // Fallback for legacy icon prop
                return <span className="emoji-icon">{this.props.icon || iconValue}</span>;
        }
    }

    render() {
        return (
            <div className={this.className}>
                <div className="service-icon">
                    {this.renderIcon()}
                </div>
                <h3 className="service-title">{this.props.title}</h3>
                <p className="service-description">{this.props.description}</p>
            </div>
        );
    }
}

export default ServiceCard;